import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { EN, VN } from '../languages';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      vi: {
        translations: VN,
      },
      en: {
        translations: EN,
      },
      
    },
    fallbackLng: 'vi',
    lng: "vi",
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'app-language',
    },
  });

export default i18n;